<div id="container">
  <app-availability-selector *ngIf="!is404" (is404)="this.is404Handler($event)"></app-availability-selector>
  <app-availability-calendar *ngIf="!is404"></app-availability-calendar>
  <app-not-found *ngIf="is404"></app-not-found>
</div>
